 
import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {externalRessourcesDto} from './defaultResponseModel/externalRessources';
const FUNCTION_CODE = 'GET_EXTERNAL_RESSOURCES';

export async function getExternalRessources(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/codev/external-resources/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return externalRessourcesDto.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
